//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getHotColumns } from '~/api/index';
export default {
  data() {
    return {
      hotColumn: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const data = await $axios(getHotColumns({ page: 1, count: 5 })).catch(
      () => {}
    );
    this.hotColumn = data?.result ?? [];
  },
  fetchKey: 'getHotColumns',
};
